import React from 'react';
import Page from '../../components/Page';
import Footer from '../../components/Footer';
import { flexContainer, wrapper, title, image, rightMargin, listBox } from './LastPageStyle';
import imgWorld from '../../assets/media/proc2-world.jpg';
import IndustryArea from '../../components/IndustryArea';

const ProcurementExcellenceLastPage = () => {
    return (
        <Page fixedPageHeight>
            <div className={flexContainer}>
                <div className={title}>ZMC navigiert Ihren Einkauf zu «Procurement Excellence»</div>
                <h2>Wir führen und entwickeln Ihren Einkauf weiter</h2>
                <p>
                    Zellweger Management Consultants (ZMC) bietet umfassende Beratungs-, Umsetzungs- &amp; Trainings-
                    sowie Durchführungsleistungen im Kompetenzfeld Einkauf.
                </p>
                <div className={wrapper}>
                    <img className={`${image} ${rightMargin}`} src={imgWorld} alt="International" />
                    <div className={listBox}>
                        <ul>
                            <li>360° Einkaufs-Assessment</li>
                            <li>Procurement Excellence-Transformation</li>
                            <li>Einkaufs-/Herstellkostenreduktion</li>
                            <li>Einkaufsstrategien &amp; -konzepte</li>
                            <li>Warengruppenmanagement, -strategien</li>
                            <li>Cross-funktionale Zusammenarbeit</li>
                            <li>Beschaffungsmarktforschung</li>
                            <li>Global Sourcing, Best Country Sourcing</li>
                            <li>Sourcing 4.0</li>
                            <li>Lieferantenmanagement</li>
                            <li>Supplier Risk Management</li>
                            <li>Cost- und Value Engineering</li>
                            <li>Beschaffungs- &amp; Inbound Logistik</li>
                            <li>Einkaufsorganisation &amp; -prozesse</li>
                            <li>Einkaufs-Controlling &amp; -Governance</li>
                            <li>Digital Procurement, Procurement 4.0</li>
                            <li>Predictive Procurement</li>
                            <li>Big Data Analytics</li>
                            <li>Cognitive Procurement</li>
                        </ul>
                    </div>
                </div>
                <h2>Namhafte Kunden vertrauen uns</h2>
                <p>Internationale Unternehmen wählen uns als Partner, um «Procurement Excellence» zu erreichen.</p>
                <IndustryArea />
                <h2>Nachhaltige Resultate und ein attraktiver Payback</h2>
                <p>
                    Sie setzen auf ein erfahrenes Team. Unser Fokus auf «Business Excellence» und unsere ausgewiesene
                    Umsetzungsstärke garantieren Ihnen nachhaltige Resultate und eine rasche Amortisation der
                    Projektkosten.
                </p>
                <div style={{ flex: 1 }} />
                <Footer />
            </div>
        </Page>
    );
};

export default ProcurementExcellenceLastPage;
